import dayjs from 'dayjs';

/**
 * A union type that represents valid date formats.
 * Add any new format to this union to ensure that all possible values are defined in one place.
 */
type DateFormat = 'YYYY-MM-DD' | 'MM/DD/YYYY';

/**
 * Formats a date string using the specified format.
 * @param dateString The date string to format.
 * @param format The format to use. Defaults to 'YYYY-MM-DD'.
 * @returns The formatted date string, or an empty string if the input is not a valid date.
 */

export const formatDateString = (dateString: string, format: DateFormat = 'YYYY-MM-DD'): string => {
  const date = dayjs(dateString);
  return date.isValid() ? date.format(format) : '';
};
